module.exports = __webpack_public_path__ + "static/img/pahs-webinar-thumb.55c58fab.jpg";